import axios from "axios";

const baseUrl = process.env.REACT_APP_API;

const getChannelsList = (userId) => {
  return axios.get(`${baseUrl}/kids-teach-kids/restrict_videos/readers/${userId}/channels/`);
};

const getMoreChannelsList = (userId, page) => {
  return axios.get(`${baseUrl}/kids-teach-kids/restrict_videos/readers/${userId}/channels/?page=${page}`);
};

const getKidChannel = (userId, channelId) => {
    return axios.get(`${baseUrl}/kids-teach-kids/restrict_videos/readers/${userId}/channels/${channelId}/`);
};

const getMoreKidChannel = (userId, channelId, page) => {
  return axios.get(`${baseUrl}/kids-teach-kids/restrict_videos/readers/${userId}/channels/${channelId}/?page=${page}`);};

const getChannelVideo = (userId, channelId, videoId) => {
    return axios.get(`${baseUrl}/kids-teach-kids/restrict_video/readers/${userId}/channels/${channelId}/watch_video/${videoId}/`);
}

const postRestrictChannelVideo = (userId, channelId, videoId) => {
    return axios.post(`${baseUrl}/kids-teach-kids/restrict_video/readers/${userId}/channels/${channelId}/restrict_video/${videoId}/`);
}

const ktkRestrictService = {
  getChannelsList,
  getKidChannel,
  getChannelVideo,
  postRestrictChannelVideo,
  getMoreKidChannel,
  getMoreChannelsList
};

export default ktkRestrictService;
